import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { VideoForm, type VideoFormValues } from "@/components/admin/videos/VideoForm";
import { throwIfNotOk } from "@/lib/api-error";
import { toast } from "@/lib/toast";
import type { VideoStatus } from "@/types";

export const Route = createFileRoute("/dashboard/admin/videos/new")({
  component: AdminNewVideo,
});

function AdminNewVideo() {
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const create = useMutation({
    mutationFn: async ({ values, status }: { values: VideoFormValues; status: VideoStatus }) => {
      const res = await fetch("/api/videos", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ ...values, title: values.title.trim(), posterUrl: values.posterUrl || null, status }),
      });
      await throwIfNotOk(res, "Kreiranje nije uspjelo");
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ["videos"] });
      navigate({ to: "/dashboard/admin/videos" });
    },
    onError: (e: Error) => toast.error(e.message),
  });

  return <VideoForm isSubmitting={create.isPending} onSubmit={(values, status) => create.mutate({ values, status })} />;
}
